import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {GetBillingInfo as GetBillingInfoQuery, BillingInfo} from 'nutshell-graphql-types';

import GET_BILLING_INFO from '../queries/get-billing-info.graphql';

export const useGetBillingInfo = (
    shouldSkip?: boolean
): {
    billingInfo: BillingInfo | null | undefined;
    refetch: () => Promise<any>;
    isLoading: boolean;
    errorMessage: string | null | undefined;
} => {
    const {data, loading, error, refetch} = useQuery<GetBillingInfoQuery, Record<any, any>>(
        GET_BILLING_INFO,
        {
            fetchPolicy: 'cache-and-network',
            skip: shouldSkip,
        }
    );

    const billingInfo = data ? data.billingInfo : null;

    return {
        billingInfo,
        refetch,
        isLoading: loading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
    };
};
